module.exports = __webpack_public_path__ + "static/media/help-tile-01@3x.00134eb0.png";